export enum APPOINTMENT_TYPE {
  CHEMOTHERAPIES='chemotherapies',
  CONSULTATIONS='consultations',
  EXAMS='exams',
  SERVICES='services',
  SURGERIES='surgeries',
  NEW_APPOITMENT='new-appointment',
  REQUEST='request',
  RESCHEDULE='reschedule',
  WAITING_LIST = 'waitinglist',
  UNKNOW = ''
}
